import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a93997d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.communityUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "Discord"
  }, [
    _createVNode(_component_SvgIcon, {
      src: _ctx.discordIcon,
      local: ""
    }, null, 8, ["src"])
  ], 8, _hoisted_1))
}